export function NarrativeSkeleton() {
  return (
    <div className="space-y-2 animate-pulse" aria-busy="true">
      <div className="h-3 w-full rounded bg-zinc-200" />
      <div className="h-3 w-[94%] rounded bg-zinc-200" />
      <div className="h-3 w-[88%] rounded bg-zinc-200" />
    </div>
  );
}
